import { useState, useEffect } from 'react';
import GoogleLoginButton from '../Buttons/GoogleLoginButton';
import NativeAuthButtons from './NativeAuthButtons';
import { Capacitor } from '@capacitor/core';

const AuthWrapper = () => {
  const [isNative, setIsNative] = useState(false);

  useEffect(() => {
    // Check if running in Capacitor native app (not web)
    // Capacitor.isNativePlatform() returns true only on iOS/Android, not on web
    const checkPlatform = () => {
      try {
        return Capacitor.isNativePlatform();
      } catch {
        return false;
      }
    };

    setIsNative(checkPlatform());
  }, []);

  // Use native authentication in Capacitor apps, web authentication otherwise
  if (isNative) {
    return <NativeAuthButtons />;
  }

  return <GoogleLoginButton />;
};

export default AuthWrapper;
